export const environment = {
  production: false,
  mailerApi: {
    url: 'http://localhost:3000/send-bulk',
    // url: 'https://smtp-mailer-hfvc.onrender.com/send-bulk',
    // url_test: 'https://smtp-mailer-hfvc.onrender.com/health', //render
    // url: 'https://campaignback.redleafsoftwares.com/send-bulk',
    key: '%$ABCS112@!!$$' // must match API_KEY in your Node .env
  }

};
